import React from 'react';

interface StatusPillProps {
  backgroundColor: string;
  /** Text/icon color. Defaults to white. */
  color?: string;
  onClick?: (event: React.MouseEvent<HTMLSpanElement>) => void;
  style?: React.CSSProperties;
  /** Stretch to the parent's full width and center the label, instead of sizing to content.
   * Table cells commonly stack more than one pill (e.g. a status pill above an Overdue pill), and
   * a table column's width is set by its widest content — so a short-label pill would otherwise
   * hug the cell's left edge with dead space beside it. */
  fillWidth?: boolean;
  children: React.ReactNode;
}

/**
 * Rounded status pill shared across the document tables and task lists — the
 * colored status/overdue pills in DocumentIndexRow and DashboardUpcomingList and
 * the consultant-review badges. Single source of truth for the pill's shape so
 * every one of them stays visually consistent.
 */
export default function StatusPill({
  backgroundColor,
  color = '#fff',
  onClick,
  style,
  fillWidth = false,
  children,
}: StatusPillProps) {
  return (
    <span
      onClick={onClick}
      style={{
        backgroundColor,
        color,
        padding: '3px 12px',
        borderRadius: '14px',
        fontSize: '13px',
        fontWeight: 600,
        whiteSpace: 'nowrap',
        display: fillWidth ? 'block' : 'inline-block',
        lineHeight: '20px',
        width: fillWidth ? '100%' : undefined,
        textAlign: fillWidth ? 'center' : undefined,
        boxSizing: fillWidth ? 'border-box' : undefined,
        ...style,
      }}
    >
      {children}
    </span>
  );
}
